import React from 'react'
import { CircleF } from '@react-google-maps/api'
import BaiduCircle from '@/component/map/baidu/BaiduCircle'
import { useMapType } from '@/component/map/MapContext'
import { wgs84ToBd09 } from '@/util/coordTransform'

export interface UnifiedCircleProps {
    center: { lat: number; lng: number }
    radius?: number
    options?: {
        fillColor?: string
        fillOpacity?: number
        strokeColor?: string
        strokeOpacity?: number
        strokeWeight?: number
    }
}

const UnifiedCircle: React.FC<UnifiedCircleProps> = ({ center, radius, options }) => {
    const { mapType } = useMapType()

    if (mapType === 'baidu') {
        const [bdLat, bdLng] = wgs84ToBd09(center.lat, center.lng)
        return (
            <BaiduCircle
                center={{ lat: bdLat, lng: bdLng }}
                radius={radius || 100}
                options={options}
            />
        )
    }

    return (
        <CircleF
            center={center}
            radius={radius}
            options={options}
        />
    )
}

export default UnifiedCircle
